import { mobileBreakpoint } from '@ps/web-core-utils';
import { useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import BackButton from '@swf/components/StarsModal/components/BackButton';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import { select } from '@swf/core/store';

import styles from './View.scss';

export interface Props {
  title?: React.ReactNode;
  nowrap?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const View: React.FC<Props> = ({ title, nowrap, children, className }) => {
  const history = useHistory();
  const { greaterThan } = useScreenSize();
  const smallScreen = !greaterThan(mobileBreakpoint);
  const isEmbedded = useSelector(select.device.isEmbedded);

  return (
    <>
      {title && !isEmbedded && (
        <header className={classNames(styles.header, { [styles.fixedHeader]: !nowrap })}>
          {smallScreen && history.length > 1 && <BackButton onClick={history.goBack} />}
          <h1>{title}</h1>
          {smallScreen && history.length > 1 && <CloseButton />}
        </header>
      )}
      {nowrap ? (
        children
      ) : (
        <section
          className={classNames(styles.section, className, {
            [styles.sectionEmbeddedAccount]: isEmbedded
          })}
        >
          {children}
        </section>
      )}
    </>
  );
};

export default View;
